import React from 'react';
import '../../../Static/Master/SalepartyReg.css';


const SearchPagination = ({ handleItemsPerPageChange, handleSearchChange, searchTerm }) => {
    return (
        <>
            <div className='div-select'>
                <span>Show</span>
                <select onClick={handleItemsPerPageChange} id='select'>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
                <span>Entries</span>

                <label className="input-label1"> Search : <input id='inpt' type="text" placeholder="Search"

                    value={searchTerm} onChange={handleSearchChange} /> </label>


            </div>
        </>
    );
}

export default React.memo(SearchPagination);